import { render, staticRenderFns } from "./FileUploadButton.vue?vue&type=template&id=b78e88a8&scoped=true&"
import script from "./FileUploadButton.vue?vue&type=script&lang=ts&"
export * from "./FileUploadButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78e88a8",
  null
  
)

export default component.exports